<mat-toolbar color="primary">
  <span>Upstream Works UDM</span>
  <div class="toolbarInfo">
    <span class="info">Region : {{region.serviceUrl}} </span>
    <span class="info">Smooch App ID : {{smoochAppId}} </span>
    <span class="info">Facebook App ID : {{facebookAppId}} </span>
    <span class="info">Twitter Environment : {{twitterEnv}} </span>
  </div>
  <span class="fill"></span>
  <span>
    <a mat-button href="javascript:;" (click)="logout()">Logout <mat-icon>exit_to_app</mat-icon></a>
  </span>
</mat-toolbar>
